import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=6e972bd6&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Notification.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification.vue
// module id = 2303
// module chunks = 1